import Glide, { Controls, Breakpoints, Swipe } from '@glidejs/glide/dist/glide.modular.esm'

let onestroyCarouselConfigs = {};

const onestoryCarousel = () => {
    const onestoryCarousels = document.querySelectorAll('.glide[data-glide-one-story-carousel-id]');
    if (onestoryCarousels) {
    Array.from(onestoryCarousels).forEach((onestoryCarousel) => {
        const id = onestoryCarousel.dataset.glideSliderId;
        if (onestoryCarousel.querySelectorAll('.glide__slide').length > 1) {
            onestroyCarouselConfigs[id] =
                new Glide(onestoryCarousel, {
                    type: 'carousel',
                    startAt: 0,
                    perView: 1,
                    breakpoints: {
                        // 1199: {
                        //   perView: 2
                        // },
                        767: {
                          perView: 1
                        }
                    },
            })

            // turn off loading screan
            onestroyCarouselConfigs[id].on('mount.after', function() {
                onestoryCarousel.querySelector('.glide__track').classList.remove('loading');
                // onestoryCarousel.querySelector('.lottie-loader').remove()
            });

            onestroyCarouselConfigs[id].mount({ Controls, Breakpoints, Swipe });
        }
    })
}
}

export default onestoryCarousel;
